// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs';
import antdPlugin from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/antd-dayjs-webpack-plugin@1.0.6/node_modules/antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/isSameOrAfter';
import advancedFormat from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/advancedFormat';
import customParseFormat from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/customParseFormat';
import weekday from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/weekday';
import weekYear from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/weekYear';
import weekOfYear from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/weekOfYear';
import isMoment from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/isMoment';
import localeData from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/localeData';
import localizedFormat from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/localizedFormat';
import duration from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/dayjs@1.11.20/node_modules/dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

dayjs.extend(antdPlugin);
